import useAjax from "@apis/useAjax";
import {
	GET_CYCLE_PURCHASE_OPTIONS_API,
	GET_CYCLE_PURCHASE_OVERVIEW_OPTIONS_API,
	POST_CYCLE_PURCHASE_API,
	POST_CYCLE_PURCHASE_OVERVIEW_API,
	GET_CYCLE_PURCHASE_API,
	DELETE_CYCLE_PURCHASE_CYCLEORDERID_API,
	POST_MEMBER_CYCLE_PURCHASE_ORDERS_API,
	GET_CYCLE_PURCHASE_TEMPORARY_API,
	POST_CYCLE_PURCHASE_TEMPORARY_CYCLEORDERID_API,
	DELETE_CYCLE_PURCHASE_TEMPORARY_CYCLEORDERID_API,
	GET_CYCLE_PURCHASE_MEMBER_RECEIVER_INFO_API,
	POST_MEMBER_CYCLE_PURCHASE_CHANGE_EMPLOYEE_API,
} from "@apis/apiPath";
import { useSnackbar } from "notistack";
import { useCallback } from "react";
import { isEmpty } from "@util/utils";

const useCyclePurchaseApi = () => {
	const Ajax = useAjax();
	const { enqueueSnackbar } = useSnackbar();

	// 取得循環訂單的下拉式選單
	const getCyclePurchaseOptionsApi = useCallback(
		async () => {
			return await Ajax.get(GET_CYCLE_PURCHASE_OPTIONS_API);
		},
		// eslint-disable-next-line
		[],
	);

	// 取得循環訂單列表
	const postCyclePurchaseOverviewApi = useCallback(
		async params => await Ajax.post(POST_CYCLE_PURCHASE_OVERVIEW_API, params),
		// eslint-disable-next-line
		[],
	);

	const getCyclePurchaseOverviewOptionsApi = useCallback(
		async () => await Ajax.get(GET_CYCLE_PURCHASE_OVERVIEW_OPTIONS_API),
		// eslint-disable-next-line
		[],
	);

	// 取得循環訂單內容
	const getCyclePurchaseMemberOrderApi = useCallback(
		async (cycleOrderID, params) => {
			return await Ajax.get(GET_CYCLE_PURCHASE_API(cycleOrderID), params);
		},
		// eslint-disable-next-line
		[],
	);

	// 新增循環訂單
	const postCyclePurchaseOrderApi = useCallback(
		async params => {
			const resp = await Ajax.post(POST_CYCLE_PURCHASE_API, params);
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	// 刪除訂購單(須為未生效)
	const deleteCyclePurchaseOrderApi = useCallback(
		async (cycleOrderID, params) => {
			const resp = await Ajax.delete(DELETE_CYCLE_PURCHASE_CYCLEORDERID_API(cycleOrderID), params);
			if (resp) enqueueSnackbar("刪除成功", { variant: "success" });
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	// 變更循環訂單擔當教練
	const postMemberCycleOrderChangeEmployeeApi = useCallback(
		async (memberID, params) => {
			const resp = await Ajax.post(POST_MEMBER_CYCLE_PURCHASE_CHANGE_EMPLOYEE_API(memberID), params);
			if (resp) enqueueSnackbar("擔當變更成功", { variant: "success" });
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	// 取得收費明細資訊
	const postCyclePurchaseOrdersApi = useCallback(
		async (memberID, parameters) => await Ajax.post(POST_MEMBER_CYCLE_PURCHASE_ORDERS_API(memberID), parameters),
		// eslint-disable-next-line
		[],
	);

	// 該會員是否有暫存資料
	const getTemporaryHasCycleOrderApi = useCallback(
		async params => await Ajax.get(GET_CYCLE_PURCHASE_TEMPORARY_API, params),
		// eslint-disable-next-line
		[],
	);

	// 儲存 暫存循環訂單
	const postTemporaryCycleOrderApi = useCallback(
		async (params, cycleOrderID) => await Ajax.post(POST_CYCLE_PURCHASE_TEMPORARY_CYCLEORDERID_API(cycleOrderID), params),
		// eslint-disable-next-line
		[],
	);

	// 刪除 暫存循環訂單
	const deleteTemporaryCycleOrderApi = useCallback(
		async cycleOrderID => await Ajax.delete(DELETE_CYCLE_PURCHASE_TEMPORARY_CYCLEORDERID_API(cycleOrderID)),
		// eslint-disable-next-line
		[],
	);

	const getCyclePurchaseMemberReceiverInfoApi = useCallback(
		async memberID => {
			return await Ajax.get(GET_CYCLE_PURCHASE_MEMBER_RECEIVER_INFO_API(memberID));
		},
		// eslint-disable-next-line
		[],
	);

	return {
		getCyclePurchaseOptionsApi,
		postCyclePurchaseOverviewApi,
		getCyclePurchaseOverviewOptionsApi,
		getCyclePurchaseMemberOrderApi,
		postCyclePurchaseOrderApi,
		deleteCyclePurchaseOrderApi,
		postCyclePurchaseOrdersApi,
		getTemporaryHasCycleOrderApi,
		postTemporaryCycleOrderApi,
		deleteTemporaryCycleOrderApi,
		getCyclePurchaseMemberReceiverInfoApi,
		postMemberCycleOrderChangeEmployeeApi,
	};
};

export default useCyclePurchaseApi;
